import React from 'react';
import {
  navigation,
  adminNavigation,
  companyAdminNavigation,
} from '@utils/links';
import { useDashboardContext } from '@pages/DashboardLayout';
import { NavLink } from 'react-router-dom';
import { Cog6ToothIcon } from '@heroicons/react/24/outline';
import { USER_ROLE, COMPANY_ROLES } from '@utils/constants';

const NavLinks = ({ setSidebarOpen }) => {
  const { user } = useDashboardContext();
  const navItems =
    user.role === USER_ROLE.GLOBAL_ADMIN ? adminNavigation : navigation;

  return (
    <nav className="flex flex-1 flex-col">
      <ul role="list" className="flex flex-1 flex-col gap-y-7">
        <li>
          <ul role="list" className="-mx-2 space-y-1">
            {navItems.map((item, index) => (
              <li key={item.name}>
                <NavLink
                  to={item.href}
                  end={index === 0}
                  onClick={() => setSidebarOpen(false)}
                >
                  {({ isActive }) => (
                    <>
                      <span
                        className={
                          isActive
                            ? 'bg-gray-50 text-svisit-primary-600 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                            : 'text-gray-700 hover:text-svisit-primary-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                        }
                      >
                        <span
                          className={
                            isActive
                              ? 'text-svisit-primary-600 h-6 w-6 shrink-0'
                              : 'text-gray-400 group-hover:text-svisit-primary-600 h-6 w-6 shrink-0'
                          }
                          aria-hidden="true"
                        >
                          {item.icon}
                        </span>
                        {item.name}
                      </span>
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </li>
        {user.companyRole === COMPANY_ROLES.COMPANY_ADMIN && user.company && (
          <li>
            <div className="text-xs/6 font-semibold text-gray-400">
              Deine Organisation
            </div>
            <ul role="list" className="-mx-2 space-y-1">
              {companyAdminNavigation.map((item) => (
                <li key={item.name}>
                  {/* Ohne `end`: auch Unterseiten (Bestellung, neue
                      Bestellung, Mitarbeiter-Detail) markieren den Eintrag. */}
                  <NavLink
                    to={item.href}
                    onClick={() => setSidebarOpen(false)}
                  >
                    {({ isActive }) => (
                      <>
                        <span
                          className={
                            isActive
                              ? 'bg-gray-50 text-svisit-primary-600 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                              : 'text-gray-700 hover:text-svisit-primary-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                          }
                        >
                          <span
                            className={
                              isActive
                                ? 'text-svisit-primary-600 h-6 w-6 shrink-0'
                                : 'text-gray-400 group-hover:text-svisit-primary-600 h-6 w-6 shrink-0'
                            }
                            aria-hidden="true"
                          >
                            {item.icon}
                          </span>
                          {item.name}
                        </span>
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>
        )}
        <li className="mt-auto">
          <NavLink to="einstellungen" end onClick={() => setSidebarOpen(false)}>
            {({ isActive }) => (
              <>
                <span
                  className={
                    isActive
                      ? 'bg-gray-50 text-svisit-primary-600 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                      : 'text-gray-700 hover:text-svisit-primary-600 hover:bg-gray-50 group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold'
                  }
                >
                  <Cog6ToothIcon
                    className={
                      isActive
                        ? 'text-svisit-primary-600 h-6 w-6 shrink-0'
                        : 'text-gray-400 group-hover:text-svisit-primary-600 h-6 w-6 shrink-0'
                    }
                    aria-hidden="true"
                  />
                  Einstellungen
                </span>
              </>
            )}
          </NavLink>
        </li>
      </ul>
    </nav>
  );
};

export default NavLinks;
